<template lang="pug">
  div
    template(v-if="isSmartPhone")
      .c-touch-box-list.u-mbm(v-if='available')
        .c-touch-box.c-touch-box--lg.c-hit(v-for="fav in wishlists", :key="fav._id")
          a.c-hit__link(:href="fav.detail_path", rel="nofollow")
          .c-touch-box__left.u-valign-middle
            vue-avatar-icon(:user="fav.user", size="sm")
          .c-touch-box__body(:class="{ 'c-media__body': !isSmartPhone }")
            strong.u-text-truncate.u-block(v-text="fav.title || 'Wish List'")
            small.u-flex
              span by&nbsp;
              a.wishlist-user.u-text-overflow-1(:href="`/${fav.user.user_name || fav.user._id}`", v-text="fav.user.name", rel="nofollow")
    template(v-else)
      .row.u-mbm(v-if='available')
        .col.s4.u-mtm(v-for="fav in wishlists", :key="fav._id")
          .c-media.c-hit
            a.c-hit__link(:href="fav.detail_path", rel="nofollow")
            .c-media__left
              vue-avatar-icon(:user="fav.user", size="sm")
            .c-media__body
              .link--inherit.strong.u-text-truncate.u-block.p-product-detail__wishlist-title(v-text="fav.title || 'Wish List'")
              small.p-product-detail__wishlist-title
                span by&nbsp;
                a.wishlist-user.u-text-overflow-1(:href="`/${fav.user.user_name || fav.user._id}`", v-text="fav.user.name" , rel="nofollow")

    .list-loading.c-loading.c-loading--opacity(v-if="loading")
    .inner(v-if="isMoreRelatedWishlist")
      button.c-btn.c-btn--fill(:class="{ 'c-btn--primary c-btn--inverse': !isSmartPhone }", @click="onClickSeeMore") See more
</template>

<script>
import urlUtil from '../../../util/url';
import avatarIcon from '../../avatar/avatarIcon.vue';

export default {
  data() {
    return {
      loading: true,
      wishlists: [],
      contents: '',
      skip: 0,
      isMoreRelatedWishlist: false
    };
  },
  components: {
    'vue-avatar-icon': avatarIcon
  },
  props: ['productId', 'wishlistDisplayNumber'],
  filters: {
    cloudImageUrl: urlUtil.cloudImageUrl,
    webp: urlUtil.webp
  },
  computed: {
    isSmartPhone() {
      return window.tom.user.isSmartPhoneDevice;
    },

    available() {
      return this.wishlists.length > 0;
    }
  },
  methods: {
    loadPublicWishlists() {
      this.loading = true;
      tom.helper
        .ajaxLoad(
          '/wishlist/getRelatedByProductId',
          {
            productId: this.productId,
            limit: parseInt(this.wishlistDisplayNumber, 10),
            skip: this.skip,
            mustReturn: '1'
          },
          'json',
          'get'
        )
        .done((data) => {
          this.loading = false;
          if (!data) {
            return;
          }
          this.skip = data.skip;
          this.isMoreRelatedWishlist = data.isMoreRelatedWishlist;
          if (data.relatedWishlists) {
            data.relatedWishlists.forEach(w => {
              this.wishlists.push(w);
            });
          }
        });
    },
    onClickSeeMore() {
      this.loadPublicWishlists();
    }
  },
  mounted() {
    this.loadPublicWishlists();
  }
};
</script>

<style scoped>
.list-loading {
  min-height: 128px;
}
.wishlist-user {
  max-width: 260px;
}
</style>
